import React, { useState, useEffect } from "react";

import OrgChart from "./OrgChart";
import QuestionSidebar from "./QuestionSidebar";

import { inject, observer } from "mobx-react";
import { getValByPath } from "@utils";

import "./style.scss";
import ButtonUI from "@UI/ButtonUI";

const Questions = inject("mainStore")(
    observer(({ mainStore, item, changeableData, prePath, disabled }) => {
        const [questions, setQuestions] = useState([]);
        const [chartData, setChartData] = useState([]);
        const [stateQuestions, setStateQuestions] = useState([]);
        const [open, setOpen] = useState(false);

        const val = prePath.length > 0 ? getValByPath(prePath.concat("surveyId").join("."), changeableData) : changeableData.surveyId;

        useEffect(() => {
            if (!val) return;

            if ((!questions.length && changeableData.surveyId) || prePath.length > 0) getQuestions();
        }, [changeableData.surveyId]);

        const getQuestions = async () => {
            const req = await mainStore.getByUrl(`/abtest/surveys/${val}`, false, "", false, false); //тут запрос вопросов
            if (req.data) {
                setStateQuestions(req.data.questionsArray);
                setQuestions(req.data.questionsArray);
            }
        };

        const handleClickChart = (e, item) => {
            if (disabled) return;
            setOpen(true);

            setTimeout(() => {
                const node = document.getElementById(e._id);

                if (!node) return;

                node.scrollIntoView({ behavior: "smooth", block: "center" });

                setTimeout(() => {
                    node.classList.add("highlight");

                    setTimeout(() => {
                        node.classList.remove("highlight");
                    }, 1000);
                }, 600);
            }, 300);
        };

        const handleAddQuestion = () => {
            setOpen(true);
        };

        const props = { questionModel, questions, stateQuestions, setQuestions, setStateQuestions, open, setOpen, changeableData, prePath, chartData, setChartData };

        return (
            <div className="questions">
                {questions ? (
                    <>
                        <OrgChart onClick={handleClickChart} {...props} />
                        <QuestionSidebar {...props} />
                    </>
                ) : null}
                {!questions?.length ? <ButtonUI className="questions__btn" disabled={disabled} onClick={handleAddQuestion} label="Добавить вопрос" outlined icon="pi pi-plus-circle" /> : null}
            </div>
        );
    }),
);

const questionModel = {
    type: "question",
    typeQuestions: "buttons",
    question: "",
    geoNotListText: "",
    geoNotListButtonText: "",
    options: [
        { text: "", isLimit: false, isLimitText: "", isLimitButtonText: "", relaitedId: null },
        { text: "", isLimit: false, isLimitText: "", isLimitButtonText: "", relaitedId: null },
    ],
    lvl: 0,
};

export default Questions;
